(function () {
  'use strict';

  var CAROUSEL_SELECTOR = '[data-amour-category-carousel]';
  var MOBILE_QUERY = '(max-width: 767px)';

  function initCarousel(root) {
    if (!root || root.dataset.amourCategoryReady === 'true') return;

    var rail = root.querySelector('[data-amour-category-rail]');
    var originals = Array.prototype.slice.call(root.querySelectorAll('[data-amour-category-card]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-amour-category-dot]'));
    if (!rail || originals.length < 2) return;

    root.dataset.amourCategoryReady = 'true';

    var count = originals.length;
    var mobileQuery = window.matchMedia(MOBILE_QUERY);
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var cards;
    var activePhysical = count;
    var settleFrame = 0;
    var wheelTimer = 0;
    var drag = null;
    var suppressClick = false;

    originals.forEach(function (card, index) {
      card.dataset.amourCategoryLogical = String(index);
    });

    function makeClone(card, index) {
      var clone = card.cloneNode(true);
      clone.classList.remove('is-active');
      clone.classList.add('is-loop-clone');
      clone.dataset.amourCategoryLogical = String(index);
      clone.setAttribute('aria-hidden', 'true');
      clone.tabIndex = -1;
      return clone;
    }

    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    originals.forEach(function (card, index) { before.appendChild(makeClone(card, index)); });
    originals.forEach(function (card, index) { after.appendChild(makeClone(card, index)); });
    rail.insertBefore(before, originals[0]);
    rail.appendChild(after);
    cards = Array.prototype.slice.call(rail.querySelectorAll('[data-amour-category-card]'));

    function logicalIndex(card) {
      return Number(card.dataset.amourCategoryLogical || 0);
    }

    function railStart() {
      return rail.getBoundingClientRect().left + parseFloat(window.getComputedStyle(rail).paddingLeft || 0);
    }

    function updateDots(logical) {
      dots.forEach(function (dot, index) {
        var selected = index === logical;
        dot.classList.toggle('is-active', selected);
        if (selected) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function applyActive(physical) {
      activePhysical = Math.max(0, Math.min(cards.length - 1, physical));
      cards.forEach(function (card, index) {
        card.classList.toggle('is-active', index === activePhysical);
      });
      updateDots(logicalIndex(cards[activePhysical]));
    }

    function applyActiveWithoutJump(physical) {
      physical = Math.max(0, Math.min(cards.length - 1, physical));
      if (physical === activePhysical) return;

      var anchor = cards[physical];
      var beforeLeft = anchor.getBoundingClientRect().left;
      applyActive(physical);
      var afterLeft = anchor.getBoundingClientRect().left;
      rail.scrollLeft += afterLeft - beforeLeft;
    }

    function nearestPhysicalIndex() {
      var start = railStart();
      var nearest = activePhysical;
      var distance = Infinity;

      cards.forEach(function (card, index) {
        if (card.offsetParent === null) return;
        var nextDistance = Math.abs(card.getBoundingClientRect().left - start);
        if (nextDistance < distance) {
          distance = nextDistance;
          nearest = index;
        }
      });
      return nearest;
    }

    function cancelSettle() {
      if (settleFrame) window.cancelAnimationFrame(settleFrame);
      settleFrame = 0;
      rail.classList.remove('is-settling');
    }

    function normalizeLoop() {
      if (!mobileQuery.matches) return;

      var logical = logicalIndex(cards[activePhysical]);
      var middle = count + logical;
      if (activePhysical === middle) return;

      var currentCard = cards[activePhysical];
      var currentOffset = currentCard.getBoundingClientRect().left - railStart();
      rail.classList.add('is-normalizing');
      applyActive(middle);

      var middleOffset = cards[middle].getBoundingClientRect().left - railStart();
      rail.scrollLeft += middleOffset - currentOffset;

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          rail.classList.remove('is-normalizing');
        });
      });
    }

    function settleToPhysical(physical) {
      if (!mobileQuery.matches) return;

      physical = Math.max(0, Math.min(cards.length - 1, physical));
      cancelSettle();
      rail.classList.add('is-settling');
      applyActive(physical);

      var selected = cards[physical];
      var duration = reducedMotion.matches ? 0 : 125;
      var started = window.performance.now();

      function settle(now) {
        var error = selected.getBoundingClientRect().left - railStart();
        var elapsed = now - started;
        var progress = duration === 0 ? 1 : Math.min(1, elapsed / duration);

        if (progress < 1 && Math.abs(error) > 0.2) {
          // Always move a fraction of the remaining distance. This cannot pass
          // the target, so the rail never overshoots and corrects backwards.
          var gain = 0.38 + (0.42 * progress);
          rail.scrollLeft += error * gain;
          settleFrame = window.requestAnimationFrame(settle);
          return;
        }

        rail.scrollLeft += error;
        settleFrame = 0;
        rail.classList.remove('is-settling');
        normalizeLoop();
      }

      settleFrame = window.requestAnimationFrame(settle);
    }

    function positionAtStart() {
      cancelSettle();
      rail.classList.add('is-normalizing');
      applyActive(count);
      window.requestAnimationFrame(function () {
        rail.scrollLeft += cards[count].getBoundingClientRect().left - railStart();
        window.requestAnimationFrame(function () {
          rail.classList.remove('is-normalizing');
        });
      });
    }

    function beginDrag(event) {
      if (!mobileQuery.matches || event.button !== 0 || settleFrame) return;
      drag = {
        id: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        startScroll: rail.scrollLeft,
        lastX: event.clientX,
        lastTime: window.performance.now(),
        velocity: 0,
        horizontal: false
      };
    }

    function moveDrag(event) {
      if (!drag || drag.id !== event.pointerId) return;

      var deltaX = event.clientX - drag.startX;
      var deltaY = event.clientY - drag.startY;
      if (!drag.horizontal) {
        if (Math.abs(deltaX) > 7 && Math.abs(deltaX) > Math.abs(deltaY)) {
          drag.horizontal = true;
          rail.classList.add('is-dragging');
          try { rail.setPointerCapture(event.pointerId); } catch (error) { /* no-op */ }
        } else if (Math.abs(deltaY) > 7 && Math.abs(deltaY) > Math.abs(deltaX)) {
          drag = null;
          return;
        }
      }

      if (!drag.horizontal) return;
      event.preventDefault();

      var now = window.performance.now();
      var elapsed = Math.max(1, now - drag.lastTime);
      drag.velocity = (event.clientX - drag.lastX) / elapsed;
      drag.lastX = event.clientX;
      drag.lastTime = now;

      rail.scrollLeft = drag.startScroll - deltaX;
      applyActiveWithoutJump(nearestPhysicalIndex());
    }

    function endDrag(event) {
      if (!drag || drag.id !== event.pointerId) return;
      var completed = drag;
      drag = null;
      rail.classList.remove('is-dragging');
      try { rail.releasePointerCapture(event.pointerId); } catch (error) { /* no-op */ }

      if (!completed.horizontal) return;
      event.preventDefault();

      var target = nearestPhysicalIndex();
      if (Math.abs(completed.velocity) > 0.45 && target === activePhysical) {
        target += completed.velocity < 0 ? 1 : -1;
      }
      target = Math.max(0, Math.min(cards.length - 1, target));

      suppressClick = true;
      window.setTimeout(function () { suppressClick = false; }, 0);
      settleToPhysical(target);
    }

    function handleWheel(event) {
      if (!mobileQuery.matches || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      event.preventDefault();
      cancelSettle();
      rail.scrollLeft += event.deltaX;
      applyActiveWithoutJump(nearestPhysicalIndex());
      window.clearTimeout(wheelTimer);
      wheelTimer = window.setTimeout(function () {
        settleToPhysical(nearestPhysicalIndex());
      }, 45);
    }

    rail.addEventListener('pointerdown', beginDrag);
    rail.addEventListener('pointermove', moveDrag, { passive: false });
    rail.addEventListener('pointerup', endDrag, { passive: false });
    rail.addEventListener('pointercancel', endDrag, { passive: false });
    rail.addEventListener('wheel', handleWheel, { passive: false });
    rail.addEventListener('click', function (event) {
      if (!suppressClick || !event.target.closest('[data-amour-category-card]')) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    rail.addEventListener('keydown', function (event) {
      if (!mobileQuery.matches || (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')) return;
      event.preventDefault();
      settleToPhysical(activePhysical + (event.key === 'ArrowRight' ? 1 : -1));
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        if (!mobileQuery.matches) return;
        var logical = Number(dot.dataset.amourCategoryDot || 0);
        var candidates = [logical, count + logical, (count * 2) + logical];
        var start = railStart();
        var closest = candidates.reduce(function (best, candidate) {
          var bestDistance = Math.abs(cards[best].getBoundingClientRect().left - start);
          var candidateDistance = Math.abs(cards[candidate].getBoundingClientRect().left - start);
          return candidateDistance < bestDistance ? candidate : best;
        }, candidates[0]);
        settleToPhysical(closest);
      });
    });

    function updateMode() {
      cancelSettle();
      window.clearTimeout(wheelTimer);
      drag = null;
      rail.classList.remove('is-dragging');
      if (mobileQuery.matches) {
        rail.classList.add('is-drag-engine');
        positionAtStart();
      } else {
        rail.classList.remove('is-drag-engine', 'is-normalizing', 'is-settling');
        rail.scrollLeft = 0;
        applyActive(count);
      }
    }

    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', updateMode);
    else mobileQuery.addListener(updateMode);

    updateMode();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(CAROUSEL_SELECTOR).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.matches && event.target.matches(CAROUSEL_SELECTOR)) initCarousel(event.target);
    else initAll(event.target);
  });
}());
